import cts from '_cts';
import apis from '_apis';
import { config } from '_actions';
import { eventTracker } from '_helpers';

import store from '../configureStore';
import getCollection from './getCollection';
import setDistrictsArray from './setDistrictsArray';

const { dispatch } = store.store;
const {
  setTitle,
  setCollection,
  setSelectedLang,
  setWebappConfiguration,
} = config;

const convertLangKeyToServersStandard = (langKey) => {
  let output = '';
  switch (langKey) {
    case 'sp_CH':
      output = 'zh-s';
      break;
    case 'tr_CH':
      output = 'zh-t';
      break;
    default:
      output = langKey.slice(0, 2).toLowerCase();
      break;
  }
  return output;
};

const changeLanguage = async (lang) => {
  try {
    const state = store.store.getState();
    const { zoneStr } = state.zone;
    const { districtId, webappConfig } = state.config;
    const { projectId, enCodePluginId } = state.plugin;
    const { has_calendar: hasCalendar } = webappConfig;

    const { data, status } = await cts('get', apis.getPluginDetails(enCodePluginId.toString(), convertLangKeyToServersStandard(lang)));

    if (
      !data
      || status !== 200
    ) throw new Error('There was a problem in downloading translation package.');

    const {
      title,
      districts,
      tab_properties,
      has_bulk_pickup = false,
      bulk_pickup_title = '',
      app_brand = '',
      app_download_android_link = '',
      app_download_branded_app = 0,
      app_download_ios_link = '',
      app_download_logo = '',
      app_download_message_long = '',
      app_download_message_short = '',
      app_download_qr_code = '',
    } = data;
    const selectedDistrictId = districtId || '';
    const districtTransformer = districts.reduce((prev, cur) => {
      const newItem = prev;
      newItem[cur.district_id] = cur;
      return newItem;
    }, {});

    const firstDefaultDistrict = selectedDistrictId
      || Object.keys(districtTransformer)[0]; // pick the first item

    /**
     * Set translated districts
     */
    setDistrictsArray(districtTransformer, firstDefaultDistrict, hasCalendar);

    dispatch(setTitle(title));

    /**
      * Set translated WWTK data
      */

    /**
     * Set selected language
     */
    dispatch(setSelectedLang(lang));

    /**
     * Set translated web app configuration tab properties
     */
    dispatch(setWebappConfiguration({
      ...tab_properties,
      has_bulk_pickup,
      bulk_pickup_title,
      app_brand,
      app_download_android_link,
      app_download_branded_app,
      app_download_ios_link,
      app_download_logo,
      app_download_message_long,
      app_download_message_short,
      app_download_qr_code,
    }));

    /**
     * Set the new translated collection (if the zone setup is done)
     */
    if (zoneStr) {
      const collections = await getCollection(projectId, districtId, zoneStr, lang);
      if (!collections) throw new Error('There was a problem in getting collections');
      dispatch(setCollection(collections));
    }

    /**
     * Language event tracker
     */
    eventTracker('Lang Switch', convertLangKeyToServersStandard(lang));

    return Promise.resolve('done');
  } catch (e) {
    return Promise.reject(e.message);
  }
};

const isRTL = () => {
  const { selectedLang: lang } = store.store.getState().config;
  return lang && !!(lang.match(/fa_IR|ar_SA|ur_UR/));
};

export {
  isRTL,
  changeLanguage,
};
